import { FC } from 'react';
import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
    percent: number;
}

const ProgressBar: FC<ProgressBarProps> = ({ percent }) => {
    return (
        <div className={styles.progressBar}>
            {percent >= 0 && percent <= 100 && (
                <div
                    style={{ width: `${percent}%` }}
                    className={styles.value}></div>
            )}
        </div>
    );
};

export default ProgressBar;
